import qs from 'qs'
import { DateFactory } from 'rhg-vue-common'

const NUMBER_OF_DAYS_OF_THE_WEEK = 7

export const redirect = (url, params) => {
  global.UtilsBrowser.redirect(url, params)
}

export const setCookie = global.Cookie.set

export function addQueryParams (url, data) {
  return url + qs.stringify(data, { addQueryPrefix: true, arrayFormat: 'brackets' })
}

export const getQueryParams = query => {
  const index = query.indexOf('#')
  if (index > 0) {
    query = query.substring(0, index)
  }
  return qs.parse(query, { ignoreQueryPrefix: true, format: 'RFC1738' })
}

export function replaceQueryParam (url, key, value) {
  const regex = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
  const separator = url.indexOf('?') !== -1 ? '&' : '?'
  if (url.match(regex)) {
    return url.replace(regex, '$1' + key + '=' + value + '$2')
  } else {
    return url + separator + key + '=' + value
  }
}

export function formatOccupancy (occupancies) {
  const rooms = occupancies.length
  const { adults, children } = occupancies.reduce((accum, room) => ({
    adults: Math.max(accum.adults, room.adults),
    children: Math.max(accum.children, room.children)
  }),
  { adults: 0, children: 0 })
  return { rooms, adults, children }
}

export function dayOfWeekToDate ({ dateFactory, types }) {
  return (dayOfWeek = 'monday') => {
    const todayNumber = dateFactory.dayOfTheWeek()
    let numberDayOfWeek = types[dayOfWeek.toLowerCase()]

    if (todayNumber >= numberDayOfWeek) {
      numberDayOfWeek = types[dayOfWeek.toLowerCase()] + NUMBER_OF_DAYS_OF_THE_WEEK
    }

    return dateFactory.dayOfTheWeekToDate(numberDayOfWeek)
  }
}

export const filterOccupancies = (adults, children) => {
  return adults.map((adult, index) => ({
    adults: !isNaN(adult) ? parseInt(adult) : 1,
    children: !isNaN(children[index]) ? parseInt(children[index]) : 1
  }))
}

export function buildImageUrl (mediaUrl, impolicy, gravity) {
  if (mediaUrl) {
    let url = mediaUrl + '?impolicy=' + impolicy
    if (gravity) {
      url += '&gravity=' + gravity
    }
    return url
  }
  return mediaUrl
}

export function buildImageUrlFromMedia (image, impolicy) {
  return buildImageUrl(image.url, impolicy, image.gravity)
}

export function isMinNightsStay (checkInDate, checkOutDate, minNightsPerStay) {
  const sumDays = DateFactory.daysBetween(checkInDate, checkOutDate)
  const minNightRate = sumDays < minNightsPerStay
  return minNightRate
}

export function isMobileDevice () {
  return global.device.mobile() || global.device.tablet() || global.innerWidth < 992
}

export function toLocale (num) {
  const lang = document.documentElement.lang || 'en-us'
  return num.toLocaleString(lang)
}

export const getHotelGalleryTriggers = (hotel) => {
  return {
    'data-gallery-type': 'hotel',
    'data-gallery-type-id': hotel.tmsCode
  }
}

export const getRoomGalleryTriggers = (hotelCode, room, hotelName) => {
  return {
    'data-gallery-type': 'rooms',
    'data-gallery-type-id': `${hotelCode}|${room.id}`,
    'data-gallery-title': hotelName
  }
}

export const getImagePosition = (room) => {
  if (room && room.gallery) {
    return room.gallery.length.toString()
  }
  return ''
}

export const getAllGalleryImagesCount = (galleries) => {
  let galleryCount = 0
  galleries.forEach((gallery) => {
    galleryCount += gallery.gallery.length
  })
  return galleryCount > 0 ? galleryCount.toString() : ''
}
export const roundPrice = (price) =>
  (price % 1 < 0.5 ? Math.floor(price) : Math.ceil(price))

export function getTranslatedTier(tier, translate) {
  switch (tier?.toLowerCase()) {
    case 'vip':
      return translate('rtVIP')
    case 'premium':
      return translate('rtPremium')
    case 'club':
      return translate('rtClub')
    default:
      return tier
  }
}
